<template>    
    <v-card>
        <!-- Titulo del dialogo -->
        <v-card-title>
            Crear Usuario
        </v-card-title>
        <v-divider></v-divider>
            <!-- Formulario -->
        <v-form ref="form">
            <v-stepper v-model="e1" class="elevation-0">
                <v-stepper-header class="elevation-0">
                    <v-stepper-step style="font-weight:bolder!important;" :complete="e1 > 1" step="1"></v-stepper-step>
                    <v-divider></v-divider>
                    <v-stepper-step style="font-weight:bolder!important;" :complete="e1 > 2" step="2"></v-stepper-step>
                    <v-divider></v-divider>
                    <v-stepper-step style="font-weight:bolder!important;" step="3"></v-stepper-step>
                </v-stepper-header>
                <v-stepper-items>
                    <v-stepper-content step="1" class="pt-0">
                        <v-row class="mx-0">
                            <v-col cols="12" sm="6" md="6">
                                <v-select item-value="id" item-text="name" v-model="editedItem.branch_id" :items="branchs" label="Sucursal"></v-select>
                            </v-col>
                            <v-col cols="12" sm="6" md="6">
                                <v-select v-model="editedItem.rol" :items="roles" item-value="name" item-text="name" label="Rol"></v-select>
                            </v-col>
                        </v-row>
                        <v-row class="mx-0">
                            <v-col cols="12" sm="6" md="6">
                                <v-select v-model="editedItem.job_position" :items="positions" label="Área"></v-select>
                            </v-col>
                            <v-col cols="12" sm="6" md="6">
                                <v-select :disabled="editedItem.job_position==''" v-model="editedItem.sub_job_position" :items="subPositions" label="Puesto"></v-select>
                            </v-col>
                        </v-row>
                        
                        <v-row class="mx-0">
                            <v-col cols="12" sm="6" md="6">
                                <v-text-field :rules="[v => !!v || 'Campo requerido']" v-model="editedItem.name" label="Nombre"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="6">
                                <v-text-field :rules="[v => !!v || 'Campo requerido']" v-model="editedItem.last" label="Apellido"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row class="mx-0">
                            <v-col cols="12" sm="6" md="6">
                                <v-text-field :rules="[v => !!v || 'Campo requerido']" v-model="editedItem.email" label="Email"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="6">
                                <v-text-field v-model="editedItem.phone" label="Teléfono"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row class="mx-0">
                            <v-col cols="12" sm="12" md="12">
                                <v-text-field :rules="[v => !!v || 'Campo requerido']" type="password" v-model="editedItem.password" label="Contraseña"></v-text-field>
                            </v-col>
                        </v-row>
                    </v-stepper-content>
                    <v-stepper-content step="2" class="pt-0">
                        <v-card-text class="pb-0 pt-0">
                            <!--strong>Datos de Empleado</strong-->
                            <v-container>
                                <v-row class="mt-0">
                                    <v-row>
                                        <v-col cols="12" sm="6" md="6">
                                            <v-menu v-model="datePicker" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px" >
                                                <template v-slot:activator="{ on }">
                                                    <v-text-field clearable required v-model="editedItem.entry_date" label="Fecha de Ingreso" prepend-icon="mdi-calendar" readonly v-on="on"></v-text-field>
                                                </template>
                                                <v-date-picker color="primary" v-model="editedItem.entry_date" @input="datePicker = false"></v-date-picker>
                                            </v-menu>
                                            <v-menu v-model="datePicker2" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px" >
                                                <template v-slot:activator="{ on }">
                                                    <v-text-field clearable required v-model="editedItem.birth_date" label="Fecha Nacimiento" prepend-icon="mdi-calendar" readonly v-on="on"></v-text-field>
                                                </template>
                                                <v-date-picker color="primary" v-model="editedItem.birth_date" @input="datePicker2 = false"></v-date-picker>
                                            </v-menu>
                                            <v-text-field v-if="editedItem.sub_job_position.toLowerCase().includes('venta')" type="number" clearable required v-model="editedItem.goal_amount" label="Meta de Venta" prepend-icon="mdi-currency-usd"></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6" md="6">
                                            <v-menu v-model="datePicker3" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px" >
                                                <template v-slot:activator="{ on }">
                                                    <v-text-field clearable required v-model="editedItem.departure_date" label="Fecha de Salida" prepend-icon="mdi-calendar" readonly v-on="on"></v-text-field>
                                                </template>
                                                <v-date-picker color="primary" v-model="editedItem.departure_date" @input="datePicker3 = false"></v-date-picker>
                                            </v-menu>
                                            <v-text-field type="number" clearable required v-model="editedItem.daily_salary" label="Sueldo Diario" prepend-icon="mdi-currency-usd"></v-text-field>
                                        </v-col>
                                    </v-row>
                                </v-row>
                            </v-container>
                        </v-card-text>
                    </v-stepper-content>
                    <v-stepper-content step="3" class="pt-0">
                        <v-card-text class="pb-0 pt-0">
                            <v-container>
                                <v-row>
                                    <v-col cols="12" sm="6" md="6">
                                        <v-text-field v-model="editedItem.payroll_fiscal_profile.legal_name" label="Nombre fiscal"></v-text-field>
                                        <v-text-field v-model="editedItem.payroll_fiscal_profile.tax_id" label="RFC"></v-text-field>
                                        <v-select v-model="editedItem.payroll_fiscal_profile.tax_system" :items="taxSystems" item-text="label" item-value="value" label="Régimen fiscal"></v-select>
                                        <v-text-field v-model="editedItem.payroll_fiscal_profile.zip" label="Código postal fiscal"></v-text-field>
                                        <v-text-field v-model="editedItem.payroll_fiscal_profile.curp" label="CURP"></v-text-field>
                                        <v-text-field v-model="editedItem.payroll_fiscal_profile.num_seguridad_social" label="NSS"></v-text-field>
                                        <v-text-field v-model="editedItem.payroll_fiscal_profile.num_empleado" label="Número de empleado"></v-text-field>
                                        <v-select v-model="editedItem.payroll_fiscal_profile.clave_ent_fed" :items="federalEntities" item-text="label" item-value="value" label="Clave entidad federativa"></v-select>
                                        <v-text-field type="number" v-model="editedItem.payroll_fiscal_profile.salario_diario_integrado" label="Salario diario integrado"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="6">
                                        <v-select v-model="editedItem.payroll_fiscal_profile.tipo_contrato" :items="contractTypes" item-text="label" item-value="value" label="Tipo contrato"></v-select>
                                        <v-select v-model="editedItem.payroll_fiscal_profile.tipo_regimen" :items="payrollRegimeTypes" item-text="label" item-value="value" label="Tipo régimen nómina"></v-select>
                                        <v-select v-model="editedItem.payroll_fiscal_profile.periodicidad_pago" :items="paymentFrequencies" item-text="label" item-value="value" label="Periodicidad pago"></v-select>
                                        <v-menu v-model="datePickerPayrollStart" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px" >
                                            <template v-slot:activator="{ on }">
                                                <v-text-field clearable v-model="editedItem.payroll_fiscal_profile.fecha_inicio_rel_laboral" label="Inicio relación laboral" prepend-icon="mdi-calendar" readonly v-on="on"></v-text-field>
                                            </template>
                                            <v-date-picker color="primary" v-model="editedItem.payroll_fiscal_profile.fecha_inicio_rel_laboral" @input="datePickerPayrollStart = false"></v-date-picker>
                                        </v-menu>
                                        <v-select v-model="editedItem.payroll_fiscal_profile.tipo_jornada" :items="workdayTypes" item-text="label" item-value="value" label="Tipo jornada"></v-select>
                                        <v-text-field v-model="editedItem.payroll_fiscal_profile.departamento" label="Departamento"></v-text-field>
                                        <v-text-field v-model="editedItem.payroll_fiscal_profile.puesto" label="Puesto fiscal"></v-text-field>
                                        <v-select v-model="editedItem.payroll_fiscal_profile.riesgo_puesto" :items="jobRiskTypes" item-text="label" item-value="value" label="Riesgo puesto"></v-select>
                                        
                                        <v-select v-model="editedItem.payroll_fiscal_profile.registro_patronal" :items="['D4242056106', 'Y4038980100']" label="Registro patronal"></v-select>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card-text>
                    </v-stepper-content>
                </v-stepper-items>
            </v-stepper>
        </v-form>
        <v-card-actions class="pt-4">
            <v-menu :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px" >
                <template v-slot:activator="{ on }">
                    <v-chip class="ma-2 mt-0" :color="editedItem.color" text-color="white" v-on="on"><v-avatar left><v-icon color="#676767"> mdi-palette</v-icon></v-avatar> Color Calendario</v-chip>
                </template>
                <v-color-picker :rules="[v => !!v || 'Campo requerido']" v-model="editedItem.color" class="ma-2"></v-color-picker>
            </v-menu> 
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
            <v-btn color="blue darken-1" text  v-if="e1>1" @click="e1 = e1-1">
                <v-icon>mdi-chevron-left</v-icon>
                Regresar
            </v-btn>
            <v-btn color="blue darken-1" text  v-if="e1!=3" @click="e1 = e1+1">
                Siguiente
                <v-icon>mdi-chevron-right</v-icon>
            </v-btn>
            <v-btn color="blue darken-1" text :loading="gris" :disabled="gris || !valid" @click="save">Guardar</v-btn>
        </v-card-actions>
        <v-snackbar :color="snackbar.color" v-model="snackbar.show">
            {{ snackbar.message }}
        </v-snackbar>
    </v-card>
</template>
<script>
import axios from "axios";
export default {
    data:()=>({ 
        datePicker: false,
        datePicker2: false,
        datePicker3: false,
        datePickerPayrollStart: false,
        e1: 1, 
        disable:'',
        valid: true,
        branchs:[],
        editedItem: {
            name:'',
            last:'',
            email:'',
            color:'',
            phone:'',
            job_position:'',
            sub_job_position:'',
            birth_date:'',
            departure_date:'',
            entry_date:'',
            daily_salary:'',
            branch_id:'',
            status:'activo',
            avatar:'default.jpg',
            payroll_fiscal_profile:{
                legal_name:'',
                tax_id:'',
                tax_system:'605',
                zip:'',
                curp:'',
                num_seguridad_social:'',
                num_empleado:'',
                tipo_contrato:'',
                tipo_regimen:'',
                periodicidad_pago:'',
                clave_ent_fed:'',
                fecha_inicio_rel_laboral:'',
                tipo_jornada:'',
                departamento:'',
                puesto:'',
                riesgo_puesto:'',
                salario_diario_integrado:'',
                registro_patronal:'',
                facturapi_customer_id:'',
                facturapi_edit_link:'',
                facturapi_edit_link_expires_at:'',
            }
        },
        rules: {
            required: value => !!value || 'Campo requerido',
        },
        snackbar: {
            show: false,
            message: null,
            color: null
        },
        gris:false,
    }),
    computed:{
        subPositions(){
            if(this.editedItem.job_position == 'Administración'){
                return ['Asistente dirección','Contabilidad']
            }else if(this.editedItem.job_position == 'Almacén'){
                return ['Calidad','Logística', 'Montacargas']
            }else if(this.editedItem.job_position == 'Comercial'){
                return ['Cobranza','Compras', 'Ecommerce','Publicidad','Ventas', 'Ventas Industria']
            }else if(this.editedItem.job_position == 'Producción'){
                return ['App','Trapo',]
            }
            return []
        },
        taxSystems(){
            return [{ value:'605', label:'605 - Sueldos y Salarios e Ingresos Asimilados a Salarios' }]
        },
        contractTypes(){
            return [
                { value:'01', label:'01 - Contrato de trabajo por tiempo indeterminado' },
                { value:'02', label:'02 - Contrato de trabajo para obra determinada' },
                { value:'03', label:'03 - Contrato de trabajo por tiempo determinado' },
                { value:'04', label:'04 - Contrato de trabajo por temporada' },
                { value:'05', label:'05 - Sujeto a prueba' },
                { value:'06', label:'06 - Capacitación inicial' },
                { value:'07', label:'07 - Pago de hora laborada' },
                { value:'08', label:'08 - Comisión laboral' },
                { value:'09', label:'09 - Modalidades de contratación' },
                { value:'10', label:'10 - Jubilación, pensión, retiro' },
                { value:'99', label:'99 - Otro contrato' },
            ]
        },
        payrollRegimeTypes(){
            return [
                { value:'02', label:'02 - Sueldos' },
                { value:'03', label:'03 - Jubilados' },
                { value:'04', label:'04 - Pensionados' },
                { value:'05', label:'05 - Asimilados miembros sociedades cooperativas' },
                { value:'06', label:'06 - Asimilados integrantes sociedades/asociaciones civiles' },
                { value:'07', label:'07 - Asimilados miembros consejos' },
                { value:'08', label:'08 - Asimilados comisionistas' },
                { value:'09', label:'09 - Asimilados honorarios' },
                { value:'10', label:'10 - Asimilados acciones' },
                { value:'11', label:'11 - Asimilados otros' },
            ]
        },
        paymentFrequencies(){
            return [
                { value:'01', label:'01 - Diario' },
                { value:'02', label:'02 - Semanal' },
                { value:'03', label:'03 - Catorcenal' },
                { value:'04', label:'04 - Quincenal' },
                { value:'05', label:'05 - Mensual' },
                { value:'06', label:'06 - Bimestral' },
                { value:'07', label:'07 - Unidad obra' },
                { value:'08', label:'08 - Comisión' },
                { value:'09', label:'09 - Precio alzado' },
                { value:'10', label:'10 - Decenal' },
                { value:'99', label:'99 - Otra periodicidad' },
            ]
        },
        workdayTypes(){
            return [
                { value:'01', label:'01 - Diurna' },
                { value:'02', label:'02 - Nocturna' },
                { value:'03', label:'03 - Mixta' },
                { value:'04', label:'04 - Por hora' },
                { value:'05', label:'05 - Reducida' },
                { value:'06', label:'06 - Continuada' },
                { value:'07', label:'07 - Partida' },
                { value:'08', label:'08 - Por turnos' },
                { value:'99', label:'99 - Otra jornada' },
            ]
        },
        jobRiskTypes(){
            return [
                { value:'1', label:'1 - Clase I' },
                { value:'2', label:'2 - Clase II' },
                { value:'3', label:'3 - Clase III' },
                { value:'4', label:'4 - Clase IV' },
                { value:'5', label:'5 - Clase V' },
                { value:'99', label:'99 - No aplica' },
            ]
        },
        federalEntities(){
            return ['AGU','BCN','BCS','CAM','CHP','CHH','CMX','COA','COL','DUR','GUA','GRO','HID','JAL','MEX','MIC','MOR','NAY','NLE','OAX','PUE','QUE','ROO','SLP','SIN','SON','TAB','TAM','TLA','VER','YUC','ZAC'].map(value => ({ value, label:value }))
        },
        positions(){
            return [
                'Administración',
                'Almacén',
                'Chofer Ejecutivo',
                'Chofer Repartidor',
                'Comercial',
                'Dirección',
                'Producción',
                'Sistemas',
            ]
        },
        roles(){
            return this.$store.state.role.roles
        }
    },
    created(){
        this.$store.dispatch('role/getRoles')
        axios.get(process.env.VUE_APP_BACKEND_ROUTE + "api/v2/branches").then(response=>{
            this.branchs = response.data
        })
    },
    methods:{
        close () {
            this.gris = false
            this.e1= 1
            this.editedItem = Object.assign({}, this.defaultItem)
            this.$nextTick(() => {
                this.$emit("closeCreateDialog", false);
            })
        },
        save () {
            axios.post(process.env.VUE_APP_BACKEND_ROUTE + "api/v2/users", this.editedItem).then(()=>{
                this.close()
            }).catch(error => {
                this.snackbar = {
                    message: error.response.data.message,
                    color: 'error',
                    show: true
                }
                this.gris = false
            })
        },
    },
}
</script>
